import React, { Fragment, FunctionComponent } from 'react';
import styles from './HeroImageDescription.module.scss';
import typographyStyles from 'styles/global/typography.module.scss';
import { Block, Link, ResponsiveImage, BlockContent, Typography } from 'components/elements';
import cx from 'clsx';
import { WPAcfHeroImageDescription } from 'types/acf/hero';
import DOMPurify from 'dompurify';

interface OwnProps {
  data: WPAcfHeroImageDescription[] | null;
}

type HeroImageDescriptionProps = JSX.IntrinsicElements['div'] & OwnProps;

const HeroImageDescription: FunctionComponent<HeroImageDescriptionProps> = props => {
  const { data: items } = props;

  if (!items) {
    return null;
  }

  return (
    <Fragment>
      {items.map((item, index) => {
        const { desktopImage, mobileImage, description, header, headerLink, buttonLabel, buttonLink, image_position, theme } = item;

        const imageClassNames = cx({
          [styles.image]: true,
          [styles.reverse]: image_position === 'right',
        });

        const headerLinkClassNames = cx({
          [styles.headerLink]: true,
          [typographyStyles.new_neue_20_h2]: true,
        });

        return (
          <Block id={`hero-description-${index}`} key={`hero-description-${index}`} theme={theme} data-module="hero-description">
            <BlockContent direction="row">
              <div className={imageClassNames}>
                <ResponsiveImage
                  desktopImage={{ config: desktopImage, imgProps: { componentHeight: true } }}
                  mobileImage={{ config: mobileImage || desktopImage }}
                />
              </div>
              <div className={styles.content}>
                {header && (
                  <Typography as="h3" mobile="new_neue_20_h2" tablet="new_neue_20_h2" desktop="new_neue_20_h2" className={styles.header}>
                    {headerLink ? (
                      <Link className={headerLinkClassNames} aria-label={`${header} - Link`} href={headerLink}>
                        {header}
                      </Link>
                    ) : (
                      header
                    )}
                  </Typography>
                )}
                {description && (
                  <Typography
                    className={styles.description}
                    mobile="new_ibm_regular_16"
                    tablet="new_ibm_regular_16"
                    desktop="new_ibm_regular_16"
                    as="div"
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
                  />
                )}
                {buttonLabel && buttonLink && (
                  <Link className={styles.link} href={buttonLink}>
                    {buttonLabel}
                  </Link>
                )}
              </div>
            </BlockContent>
          </Block>
        );
      })}
    </Fragment>
  );
};

export default HeroImageDescription;
